// Cadeiras da Conta Empresa (2026-10-01): o plano inclui usuários (Free 1,
// Starter 2, Pro 5, Business 10), a empresa pode ter cadeiras de cortesia e,
// com a assinatura no cartão, cadeiras adicionais pagas. O backend manda o
// estado em meta.seats (lista de membros) e em GET /companies/:id/seats.

// Reserva quando o catálogo ainda não traz limits.included_seats (mesma
// tabela do SALES_PLANS_CONFIG da InfinitAgents).
export const INCLUDED_SEATS_BY_PLAN = {
  sales_free: 1,
  sales_starter: 2,
  sales_pro: 5,
  sales_business: 10,
};

export function includedSeatsOf(plan) {
  const doCatalogo = (plan?.limits || {}).included_seats;
  if (doCatalogo != null) return doCatalogo;
  return INCLUDED_SEATS_BY_PLAN[plan?.id] ?? null;
}

export function formatBRL(valor) {
  return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function seatsFull(seats) {
  return !!seats && Number(seats.used) >= Number(seats.total);
}

// "5 no plano + 11 de cortesia + 2 adicionais"
export function seatsBreakdown(seats) {
  if (!seats) return '';
  const partes = [`${seats.included} no plano`];
  if (seats.granted_extra > 0) partes.push(`${seats.granted_extra} de cortesia`);
  if (seats.paid_extra > 0) {
    partes.push(`${seats.paid_extra} ${seats.paid_extra === 1 ? 'adicional' : 'adicionais'}`);
  }
  return partes.join(' + ');
}

// O que fazer quando não há cadeira livre: comprar (cartão), ativar a
// cobrança (plano por concessão), assinar (Free) ou falar com o suporte.
export function seatBlockKind(seats) {
  if (!seats || !seatsFull(seats)) return null;
  if (seats.used >= seats.max_total_users) return 'limit';
  if (seats.can_buy) return 'buy';
  if (seats.billing === 'manual') return 'subscription';
  if (seats.billing === 'free' || seats.has_access === false) return 'upgrade';
  return 'limit';
}
